import IconBase, { IconBaseProps } from "./IconBase";

const UngroupIcon = (props: IconBaseProps) => (
  <IconBase {...props}>
    <g transform="rotate(-90 10 10)" fill="none" fillRule="evenodd">
      <path
        d="M15.5 8A1.5 1.5 0 0 1 17 9.5V15a2 2 0 0 1-2 2H9.5A1.5 1.5 0 0 1 8 15.5h0"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        x="3"
        y="3"
        width="9"
        height="9"
        rx="4.5"
      />
    </g>
  </IconBase>
);

export default UngroupIcon;
